import { faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { FC, useState } from 'react'
import { Button, ToastId, Toasts, FormikOption, FormikSelect, FormikDatePicker, Checkbox, ButtonRow } from '@tnwinc/navex-react'
import { Field, Form, Formik } from "formik"
import { object, string } from "yup"
import { Timezones } from '../PowerBIEmbeddedDashboard/TimeZones'
import { setHours, setMinutes } from "date-fns"
import { ButtonSpinner } from '../Shared/Spinner'
import { IGetSubscription, upsertPowerBiSubscription } from "./SubscriptionApi"
import { NoDataError } from "../Shared/Error"
import { pathPrefix } from "../../Api/urls"
import { insightAppHistory } from "../InsightsApp/InsightsApp"
import { SubscriptionListItem } from "./SubscriptionListItem"


interface IProps {
    SubscriptionDetails: IGetSubscription[],
    leftNavMenu: string[],
    refetch: () => void,
    email: string,
    productPermissions: string[]
}

const timeZones = Timezones
const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
export const ManageSubscription: FC<IProps> = (props) => {
    const subscribeNames: string[] = props.SubscriptionDetails.map((item: any) => item.subscriptionName);
    const [showModal, setShowModal] = useState(false)
    const [path, setPath] = useState(true)
    const [isSaving, setIsSaving] = useState(false)
    const [subscriptionId, setSubscriptionId] = useState(undefined as number | undefined)
    const subscriptionDetails = props.SubscriptionDetails.filter((item: any) => item.subscriptionId === subscriptionId)

    const chooseWeekday: string[] = (() => {
        if (subscriptionDetails[0]?.weekOfFrequency && subscriptionDetails[0]?.weekOfFrequency !== "null") {
            return subscriptionDetails[0].weekOfFrequency
                .split(",")
                .filter(Boolean)
                .map((item: string) => item.replace(/"/g, "").trim());
        }
        return [days[0]];
    })();

    switch (subscriptionDetails[0]?.frequency) {
        case 2:
            subscriptionDetails[0].frequency = "Daily"
            break
        case 3:
            subscriptionDetails[0].frequency = "Weekly"
            break
        case 4:
            subscriptionDetails[0].frequency = "Monthly"
            break
    }

    let toastId: ToastId = 0
    const [upsert] = upsertPowerBiSubscription({
        onSuccess: () => {
            toastId = Toasts.success("Saved Successfully")
            props.refetch()
            handleClose()
            setSubscriptionId(undefined)
        },
        onError: (result: any) => {
            if (result[0]!.response!.data!.errors[0]!.message) {
                if (!Toasts.isActive(toastId)) {
                    toastId = Toasts.alert(result[0].response.data.errors[0].message)
                }
            }
            else {
                if (!Toasts.isActive(toastId)) {
                    toastId = Toasts.alert("An error occurred processing your request. Please try again.")
                }
            }
        }
    })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target
        if (checked) {
            chooseWeekday.push(value)
        }
        else {
            const index = chooseWeekday.indexOf(value);
            if (index > -1) {
                chooseWeekday.splice(index, 1);
            }
        }
    }

    const handleClose = () => {
        if (window.location.href.substring(window.location.href.lastIndexOf("/") + 1) !== "*") {
            insightAppHistory.push(`${pathPrefix}/Manage_Subscription/*`, {})
        }
        else {
            setShowModal(false)
            setPath(false)
            setSubscriptionId(undefined)
        }
    }

    const computeWeekdayString = (weekdays: string[]) => {
        let result = ""
        weekdays.forEach((day, index) => {
            if (index === weekdays.length - 1) {
                result += "\"" + day + "\""
            }
            else {
                result += "\"" + day + "\"" + ","
            }
        })
        return result
    }
    let reportName = "";
    let reportNameList: string[] = [];
    if (subscriptionDetails[0]?.reportId) {
        props.leftNavMenu.forEach((item: any) => {
            item.forEach((report: any) => {
                if (report.reportId === subscriptionDetails[0].reportId) {
                    reportName = report.displayName;
                }
            });
        });
    }
    props.leftNavMenu.map((item: any) => item.map((report: any) => reportNameList.push(report.displayName)));

    return (<>
        {showModal || (window.location.href.substring(window.location.href.lastIndexOf("/") + 1) !== "*" && path) ? <Formik
            initialValues={subscriptionId !== undefined ? {
                SubscriptionName: subscriptionDetails[0].subscriptionName,
                ReportName: reportName,
                EmailRecipient: subscriptionDetails[0].recipients,
                Format: subscriptionDetails[0].reportTypeFormat,
                StartDate: new Date(new Date(subscriptionDetails[0].subscriptionStartDate).setHours(0, 0, 0)),
                EndDate: "",
                Frequency: subscriptionDetails[0].frequency,
                WeekDay: chooseWeekday.length > 0 ? chooseWeekday : "",
                MonthOnDays: subscriptionDetails[0].monthOfFrequency ? subscriptionDetails[0].monthOfFrequency : "",
                Hour: new Date(subscriptionDetails[0].subscriptionStartDate).getHours() > 12 ? (new Date(subscriptionDetails[0].subscriptionStartDate).getHours() - 12).toString() : new Date(subscriptionDetails[0].subscriptionStartDate).getHours().toString(),
                Mins: new Date(subscriptionDetails[0].subscriptionStartDate).getMinutes().toString() === "0" ? "00" : new Date(subscriptionDetails[0].subscriptionStartDate).getMinutes().toString(),
                Meridiem: new Date(subscriptionDetails[0].subscriptionStartDate).getHours() >= 12 ? "PM" : "AM",
                TimeZone: subscriptionDetails[0].timezone
            } : {
                SubscriptionName: "",
                ReportName: window.location.href.substring(window.location.href.lastIndexOf("/") + 1) !== "*" ? props.leftNavMenu.map((item: any) => item.map((report: any) => { if (report.reportId === window.location.href.substring(window.location.href.lastIndexOf("/") + 1)) { return report.displayName } })).toString().replace(/,/g, "").trim() : "",
                EmailRecipient: props.email,
                Format: "",
                StartDate: "",
                EndDate: "",
                Frequency: "",
                WeekDay: "",
                MonthOnDays: "",
                Hour: "",
                Mins: "",
                Meridiem: "",
                TimeZone: ""
            }}
            onSubmit={async (values, actions) => {
                if (values.Frequency === "Weekly" && chooseWeekday.length === 0) {
                    Toasts.alert("Select at least one weekday");
                    setIsSaving(false)
                    actions.setSubmitting(false);
                    return;
                }
                const inputEmails = values.EmailRecipient.split(",").map((e: string) => e.trim().toLowerCase()).filter(Boolean);
                const currentReportId = props.leftNavMenu
                    .flatMap((item: any) => item)
                    .find((report: any) => report.displayName === values.ReportName)?.reportId;

                const duplicateEmails = inputEmails.filter(email =>
                    props.SubscriptionDetails.some(sub =>
                        sub.reportId === currentReportId &&
                        sub.subscriptionId !== subscriptionId &&
                        sub.recipients
                            .split(",")
                            .map((e: string) => e.trim().toLowerCase())
                            .includes(email)
                    )
                );

                if (duplicateEmails.length > 0) {
                    Toasts.alert(`One or more email(s) already have an active subscription to ${values.ReportName}.`);
                    setIsSaving(false);
                    actions.setSubmitting(false);
                    return;
                }
                setIsSaving(true)
                actions.setSubmitting(true)
                var hour = values.Meridiem === "PM" && values.Hour !== "12" ? Number(values.Hour) + 12 : values.Meridiem === "AM" && values.Hour === "12" ? Number(values.Hour) - 12 : Number(values.Hour)
                await upsert({
                    SubscriptionId: subscriptionId === undefined ? -1 : subscriptionId,
                    ReportId: currentReportId,
                    SubscribeName: values.SubscriptionName,
                    RecipientMailId: values.EmailRecipient,
                    ReportTypeFormat: values.Format,
                    SubscriptionStartDate: new Date(Date.UTC(
                        new Date(values.StartDate).getFullYear(),
                        new Date(values.StartDate).getMonth(),
                        new Date(values.StartDate).getDate(),
                        hour,
                        Number(values.Mins),
                        0
                    )),
                    Frequency: values.Frequency,
                    Status: true,
                    Timezone: values.TimeZone,
                    ReportUrl: window.location.origin + '/analytics/Reports/',
                    WeekOfFrequency: values.Frequency === "Weekly" && chooseWeekday ? computeWeekdayString(chooseWeekday) : null,
                    MonthOfFrequency: values.Frequency === "Monthly" && values.MonthOnDays ? values.MonthOnDays : null,
                    author: props.email
                })
                setIsSaving(false)
                actions.setSubmitting(false)
            }}

            validationSchema={object().shape({
                SubscriptionName: subscriptionId === undefined ? string()
                    .required("Enter Subscription Name").notOneOf(subscribeNames, "Name already exists") : string().required("Enter Subscription Name"),
                ReportName: string()
                    .required("Choose Report Name"),
                EmailRecipient: string().matches(/^(?!.*(\b\s*(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*\b).*\b\1\b)\s*(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*(?:,\s*(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*)*$/g, "Enter valid, non-repeating email recipient(s) separated by comma")
                    .required("Enter Email Recipient(s)"),
                Format: string()
                    .required("Choose Format"),
                StartDate: string()
                    .required("Set Start Date"),
                Frequency: string()
                    .required("Choose Frequency"),
                Hour: string()
                    .required("Choose Hour(s)"),
                Mins: string()
                    .required("Choose Min(s)"),
                Meridiem: string()
                    .required("Choose AM/PM"),
                TimeZone: string()
                    .required("Choose Time Zone"),
                MonthOnDays: string().when("Frequency", {
                    is: "Monthly",
                    then: string().matches(/^(?!.*(\b(?:[1-9]|[1-2]\d|3[0-1])\b).*\b\1\b)(?:[1-9]|[1-2]\d|3[0-1])(?:,(?:[1-9]|[1-2]\d|3[0-1]))*$/g, "Enter valid non-repeating day(s) separated by comma")
                        .required("Enter Day(s) of the Month")
                })
            })}
            validateOnBlur
        >
            {({ values,
                errors,
                touched,
                setFieldValue,
                setFieldTouched,
                isSubmitting, }) => (
                <Form className="container-fluid" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <div className="form-group">
                                <label className="control-label" htmlFor="SubscriptionName">Subscription Name
                                    <span className="validation-required">{" * "}</span>
                                    {errors.SubscriptionName && touched.SubscriptionName ? (<span className="validation-label" aria-hidden="false">{errors.SubscriptionName}</span>) : null}
                                </label>
                                <div className="form-control-feedback-group">
                                    <Field id="SubscriptionName" name="SubscriptionName" className="form-control" aria-describedby="name-help-block"
                                        aria-invalid={errors.SubscriptionName && touched.SubscriptionName} aria-required="true" placeholder="Enter name here"
                                        required />
                                    <span className="add-clear-x form-control-feedback" style={{
                                        color: "rgb(51, 51, 51)",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        overflow: "hidden",
                                        position: "absolute",
                                        pointerEvents: "auto",
                                        right: 0,
                                        top: 0,
                                        zIndex: "auto",
                                        display: values.SubscriptionName.length > 0 ? undefined : "none",
                                    }}
                                        onClick={() => setFieldValue("SubscriptionName", "")}
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </span>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label" htmlFor="ReportName">Report Name
                                    <span className="validation-required">{" * "}</span>
                                    {errors.ReportName && touched.ReportName ? (<span className="validation-label" aria-hidden="false">{errors.ReportName}</span>) : null}
                                </label>
                                <div className="form-control-feedback-group">
                                    <Field id="ReportName" component={FormikSelect} name="ReportName"
                                        aria-invalid={errors.ReportName && touched.ReportName} aria-required="true" title={values.ReportName ? values.ReportName : "Select Report Name"}
                                        required maxMenuHeight="200px" validationErrorMessage=""
                                        onChange={(value: any) => { setFieldValue('ReportName', value) }} >
                                        {reportNameList.map((yo, idx) => {
                                            return <FormikOption value={yo} key={yo + idx}>{yo}</FormikOption>
                                        })}</Field>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label" htmlFor="EmailRecipient">Recipient(s)
                                    <span className="validation-required">{" * "}</span>
                                    {errors.EmailRecipient && touched.EmailRecipient ? (<span className="validation-label" aria-hidden="false">{errors.EmailRecipient}</span>) : null}
                                </label>
                                <div className="form-control-feedback-group">
                                    <Field id="EmailRecipient" name="EmailRecipient" className="form-control" aria-describedby="name-help-block" placeholder="Enter email id('s) separated by comma"
                                        aria-invalid={errors.EmailRecipient && touched.EmailRecipient} aria-required="true"
                                        required
                                        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                            const trimmedValue = e.target.value.replace(/\s+/g, '');
                                            setFieldValue("EmailRecipient", trimmedValue, true);
                                            setFieldTouched("EmailRecipient", true, false);
                                        }}
                                    />
                                    <span className="add-clear-x form-control-feedback" style={{
                                        color: "rgb(51, 51, 51)",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        overflow: "hidden",
                                        position: "absolute",
                                        pointerEvents: "auto",
                                        right: 0,
                                        top: 0,
                                        zIndex: "auto",
                                        display: values.EmailRecipient.length > 0 ? undefined : "none",
                                    }}
                                        onClick={() => setFieldValue("EmailRecipient", "")}
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </span>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="control-label" htmlFor="Format">Format
                                    <span className="validation-required">{" * "}</span>
                                    {errors.Format && touched.Format ? (<span className="validation-label" aria-hidden="false">{errors.Format}</span>) : null}
                                </label>
                                <div className="form-control-feedback-group">
                                    <Field id="Format" component={FormikSelect} name="Format"
                                        aria-invalid={errors.Format && touched.Format} aria-required="true" title={values.Format ? values.Format : "Select Format"}
                                        required maxMenuHeight="200px" validationErrorMessage=""
                                        onChange={(value: any) => { setFieldValue('Format', value) }} >
                                        {['PDF', 'PPTX'].map(yo => {
                                            return <FormikOption value={yo} key={yo}>{yo}</FormikOption>
                                        })}</Field>
                                </div>
                            </div>

                            {/* <label className="control-label" htmlFor="ScheduledDate">Scheduled Date
                                <span className="validation-required">{" * "}</span>
                            </label> */}
                            <table id="ScheduledDate">
                                <tbody>
                                    <tr>
                                        <th scope="col" style={{ columnWidth: "300px" }}><Field
                                            id="StartDate"
                                            name="StartDate"
                                            label="Scheduled Start Date"
                                            required
                                            minDate={setHours(setMinutes(new Date(), 0), 12)}
                                            //maxDate={values.EndDate ? values.EndDate : ""}
                                            shouldCloseOnSelect
                                            validationErrorMessage="Set Start Date"
                                            component={FormikDatePicker}
                                            openToDate={new Date()}
                                            onChange={(value: any) => {
                                                setFieldValue('StartDate', value)
                                            }}
                                        />
                                        </th>
                                        {/* <th scope="col" style={{ paddingLeft: "1rem" }} />
                                        <th scope="col" style={{ columnWidth: "300px" }}><Field
                                            id="EndDate"
                                            name="EndDate"
                                            label="End Date"
                                            minDate={values.StartDate ? values.StartDate : setHours(setMinutes(new Date(), 0), 12)}
                                            shouldCloseOnSelect
                                            component={FormikDatePicker}
                                            openToDate={new Date()}
                                            onChange={(value: any) => {
                                                setFieldValue('EndDate', value)
                                            }}
                                        />
                                        </th> */}
                                    </tr>
                                </tbody>
                            </table>

                            <div className="form-group">
                                <label className="control-label" htmlFor="Frequency">Frequency
                                    <span className="validation-required">{" * "}</span>
                                    {errors.Frequency && touched.Frequency ? (<span className="validation-label" aria-hidden="false">{errors.Frequency.toString()}</span>) : null}
                                </label>
                                <div className="form-control-feedback-group">
                                    <Field id="Frequency" component={FormikSelect} name="Frequency"
                                        aria-invalid={errors.Frequency && touched.Frequency} aria-required="true" title={values.Frequency ? values.Frequency : "Select Frequency"}
                                        required maxMenuHeight="200px" validationErrorMessage=""
                                        onChange={(value: any) => { setFieldValue('Frequency', value) }} >
                                        {['Daily', 'Weekly', 'Monthly'].map(yo => {
                                            return <FormikOption value={yo} key={yo}>{yo}</FormikOption>
                                        })}</Field>
                                </div>
                            </div>
                            {values.Frequency === 'Weekly' ?
                                <div className="form-group">
                                    <label className="control-label" htmlFor="WeekDay">Weekday(s)
                                        <span className="validation-required">{" * "}</span>
                                        {chooseWeekday.length === 0 ? (<span className="validation-label" aria-hidden="false">{errors.WeekDay}</span>) : null}
                                    </label>
                                    <table id="Weekdays">
                                        <tbody>
                                            <tr>
                                                <th scope="col">
                                                    {days.map(item =>
                                                        <Checkbox
                                                            key={item}
                                                            defaultChecked={chooseWeekday.includes(item)}
                                                            className={item}
                                                            name={item}
                                                            label={item}
                                                            value={item}
                                                            id={item}
                                                            onChange={handleChange} enterKeyHint={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} crossOrigin={undefined} />
                                                    )}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> :
                                values.Frequency === 'Monthly' ?
                                    <div className="form-group">
                                        <label className="control-label" htmlFor="MonthOnDays">Every month on day(s)
                                            <span className="validation-required">{" * "}</span>
                                            {errors.MonthOnDays && touched.MonthOnDays ? (<span className="validation-label" aria-hidden="false">{errors.MonthOnDays}</span>) : null}
                                        </label>
                                        <div className="form-control-feedback-group">
                                            <Field id="MonthOnDays" name="MonthOnDays" className="form-control" aria-describedby="name-help-block"
                                                aria-invalid={errors.MonthOnDays && touched.MonthOnDays} aria-required="true" placeholder="Ex. 1,16,29"
                                                required multiple />
                                            <span className="add-clear-x form-control-feedback" style={{
                                                color: "rgb(51, 51, 51)",
                                                cursor: "pointer",
                                                textDecoration: "none",
                                                overflow: "hidden",
                                                position: "absolute",
                                                pointerEvents: "auto",
                                                right: 0,
                                                top: 0,
                                                zIndex: 100,
                                                display: values.MonthOnDays && values.MonthOnDays.length > 0 ? undefined : "none",
                                            }}
                                                onClick={() => setFieldValue("MonthOnDays", "")}
                                            >
                                                <FontAwesomeIcon icon={faTimes} />
                                            </span>
                                        </div>
                                    </div> : ""}

                            {<div className="form-group">
                                <label className="control-label" htmlFor="TimeZone">Time Zone
                                    <span className="validation-required">{" * "}</span>
                                    {errors.TimeZone && touched.TimeZone ? (<span className="validation-label" aria-hidden="false">{errors.TimeZone}</span>) : null}
                                </label>
                                <div className="form-control-feedback-group">
                                    <Field id="TimeZone" component={FormikSelect} name="TimeZone"
                                        aria-invalid={errors.TimeZone && touched.TimeZone} aria-required="true" title={values.TimeZone ? values.TimeZone : "Select Time Zone"}
                                        required maxMenuHeight="200px" validationErrorMessage=""
                                        onChange={(value: any) => { setFieldValue('TimeZone', value) }} >
                                        {timeZones.map(tz => {
                                            return <FormikOption value={tz.value} key={tz.text}>{tz.text}</FormikOption>
                                        })}</Field>
                                </div>
                            </div>}

                            {<div className="form-group">
                                <label className="control-label" htmlFor="ScheduledTime">Scheduled Time
                                    <span className="validation-required">{" * "}</span>
                                </label>
                                <table id="ScheduledTime" className="">
                                    <tr>
                                        <th scope="col">
                                            <Field id="Hour" component={FormikSelect} name="Hour"
                                                aria-invalid={errors.Hour && touched.Hour} aria-required="true"
                                                required maxMenuHeight="200px" title={values.Hour ? values.Hour : "Hour(s)"}
                                                onChange={(value: any) => { setFieldValue('Hour', value) }} >
                                                {['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'].map(yo => {
                                                    return <FormikOption value={yo} key={yo}>{yo}</FormikOption>
                                                })}
                                            </Field>
                                        </th>
                                        <th scope="col" style={{ paddingLeft: "1rem" }}>
                                            <Field id="Mins" component={FormikSelect} name="Mins"
                                                aria-invalid={errors.Mins && touched.Mins} aria-required="true"
                                                required maxMenuHeight="200px" title={values.Mins ? values.Mins : "Min(s)"}
                                                onChange={(value: any) => { setFieldValue('Mins', value) }} >
                                                {['00', '15', '30', '45'].map(yo => {
                                                    return <FormikOption value={yo} key={yo}>{yo}</FormikOption>
                                                })}
                                            </Field>
                                        </th>
                                        <th scope="col" style={{ paddingLeft: "1rem" }}>
                                            <Field id="Meridiem" component={FormikSelect} name="Meridiem"
                                                aria-invalid={errors.Meridiem && touched.Meridiem} aria-required="true"
                                                required maxMenuHeight="200px" title={values.Meridiem ? values.Meridiem : "AM/PM"}
                                                onChange={(value: any) => { setFieldValue('Meridiem', value) }} >
                                                {['AM', 'PM'].map(yo => {
                                                    return <FormikOption value={yo} key={yo}>{yo}</FormikOption>
                                                })}</Field>
                                        </th>
                                    </tr>
                                </table>
                            </div>}
                            <div className="form-group d-flex justify-content-end">
                                <ButtonRow>
                                    <Button onClick={handleClose}>Cancel</Button>
                                    <Button purpose="primary" type="submit" id="btnCreate" disabled={isSubmitting}>{isSaving ? <>Saving...<ButtonSpinner /></> : "Save"}</Button>
                                </ButtonRow>
                            </div>
                        </div>
                    </div>
                </Form>
            )
            }
        </Formik> :
            <table id="subscriptionTable" className="table table-striped table-bordered">
                <thead>
                    <tr style={{
                        backgroundColor: "#edecec"
                    }}>
                        <th scope="col" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>Subscription Name</th>
                        <th scope="col" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>Report Name</th>
                        <th scope="col" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>Recipients</th>
                        <th scope="col" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>Frequency</th>
                        <th scope="col" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>Author</th>
                        <th scope="col" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>Actions</th>
                        <th scope="col" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>
                            <Button purpose="primary" id="AddSubscription" style={{ float: "right" }} onClick={() => setShowModal(true)}>New Subscription</Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {props.SubscriptionDetails.length > 0 ? (props.SubscriptionDetails.map((item: any) => {
                        const reportName = props.leftNavMenu.flatMap((menu: any) => menu)
                            .find((report: any) => report.reportId === item.reportId)?.displayName;

                        if (!reportName) {
                            return null;
                        }

                        return <SubscriptionListItem key={item.subscriptionId} subscriptionId={item.subscriptionId} subscription={item}
                            reFetch={props.refetch} setSubscriptionId={setSubscriptionId} setShowModal={setShowModal} leftNavMenu={props.leftNavMenu}
                            email={props.email} productPermissions={props.productPermissions} subscriptionDetails={props.SubscriptionDetails}
                        />
                    })) : (<tr>
                        <td colSpan={7}><NoDataError /></td></tr>)}
                </tbody>
            </table>}
    </>
    )
}